<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    :title="resolvedTitle"
    :type-modal="typeModal"
  >
    <div class="modal-content__main">
      <d-form @submit="send()">
        <d-form-row>
          <!-- Message -->
          <d-col md="12">
            <p v-html="resolvedMessage"></p>
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="onCancel()"
        class="btn btn-sm btn-secondary mr-4"
      >
        {{ resolvedCancelLabel }}
      </d-button>
      <d-button
        type="button"
        @click="onConfirm()"
        class="btn btn-sm btn-primary"
      >
        {{ resolvedConfirmLabel }}
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';

export default {
  name: 'confirmation-modal',
  props: {
    message: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    cancelLabel: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: '',
    },
    typeModal: {
      type: String,
      default: 'confirm_modal',
    },
    confirm: {
      type: Function,
      default: () => {},
    },
    cancel: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    resolvedTitle() {
      return this.title || this.$t('shared.confirmation.title');
    },
    resolvedMessage() {
      return this.message || this.$t('shared.confirmation.message');
    },
    resolvedCancelLabel() {
      return this.cancelLabel || this.$t('shared.actions.cancel');
    },
    resolvedConfirmLabel() {
      return this.confirmLabel || this.$t('shared.actions.confirm');
    },
  },
  components: {
    ModalTemplate,
  },
  methods: {
    ...mapActions(['setToggle']),
    onCancel() {
      this.cancel();
    },
    onConfirm() {
      this.confirm();
    },
  },
};
</script>
<style lang="scss">
@media (min-width: 992px) {
  .modal-sm {
    max-width: 550px;
  }
}
</style>
<style lang="scss" scoped>
.modal-sm {
  p {
    margin-bottom: 0;
  }
}
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
